import React, { Fragment, useContext, useEffect } from 'react'
import GithubContext from '../context/github/githubContext'
import Repos from './Repos'
import Spinner from './Spinner'

const UserDetails = (props) => {
  const contxt = useContext(GithubContext)

  const { getUser, loading, user, getUserRepos } = contxt

  useEffect(() => {
    getUser(props.match.params.login)
    getUserRepos(props.match.params.login)
  }, [props.match.params.login])

  const {
    name,
    avatar_url,
    location,
    bio,
    blog,
    login,
    html_url,
    followers,
    following,
    public_repos,
    public_gists,
    company,
    hireable,
  } = user
  return (
    <div>
      {loading ? (
        <Spinner />
      ) : (
        <>
          <h3>
            Hireable:
            {hireable ? (
              <i className='fas fa-check-double text-success'></i>
            ) : (
              <i className='fas fa-times-circle text-danger'></i>
            )}
          </h3>
          <div className='card grid-2'>
            <div className='all-center'>
              <img
                src={avatar_url}
                className='round-img'
                alt={name}
                style={{ width: '150px' }}
              />
              <h1>{name}</h1> <p>Location: {location}</p>
            </div>
            <div>
              {bio && (
                <Fragment>
                  <h3> Bio </h3>
                  <p> {bio} </p>
                </Fragment>
              )}
              <a href={html_url} className='btn btn-dark my-1'>
                GitHub Profile
              </a>
              <ul>
                <li>
                  {login && (
                    <Fragment>
                      <strong>Username: </strong> {login}
                    </Fragment>
                  )}
                </li>
                <li>
                  {company && (
                    <Fragment>
                      <strong>Company: </strong> {company}
                    </Fragment>
                  )}
                </li>
                <li>
                  {blog && (
                    <Fragment>
                      <strong>Blog: </strong> {blog}
                    </Fragment>
                  )}
                </li>
              </ul>
            </div>
          </div>
          <div className='card text-center'>
            <div className='badge badge-primary'>Followers: {followers}</div>
            <div className='badge badge-success'>Following: {following}</div>

            <div className='badge badge-light'>
              Public Repos: {public_repos}
            </div>
            <div className='badge badge-dark'>Public Gists: {public_gists}</div>
          </div>
          <Repos repos={props.repos} />
        </>
      )}
    </div>
  )
}

export default UserDetails
